import React from 'react';
import { Skeleton } from 'chic-ui';
import { Row } from 'react-bootstrap';

const WidthHeight = () => {
  return (
    <>
      <h4 className="mt-5">Width and Height</h4>
      <p>
        Change the dimensions of the skeleton using the <i>width</i> and <i>height</i> props.
      </p>
      <div className="btn-group btns mt-3">
        <Skeleton className="single-btn" />
        <Skeleton className="single-btn" width={80} height={60} />
      </div>
    <Row className="mt-5" fluid>
    <code>
      {'import { Skeleton } from "chic-ui";'}
      <br />
      {'<Skeleton />'}
      <br />
      {'<Skeleton width={80} height={60} />'}
      </code>
      </Row>
      </>
  );
};

export default WidthHeight;
